"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatMoney = formatMoney;
exports.prettifyPhoneNumber = prettifyPhoneNumber;
exports.formatPhone = formatPhone;

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.string.match.js");

function formatMoney(input) {
  if (input === null || typeof input !== 'number') return;
  return "$".concat(input.toFixed(2));
}

function prettifyPhoneNumber() {
  let phoneNumberString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const cleaned = "".concat(phoneNumberString.replace(/\D/g, ''));
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return "(".concat(match[1], ") ").concat(match[2], "-").concat(match[3]);
  }

  return null;
}

function formatPhone(value) {
  return value ? "(".concat(value.slice(0, 3), ") ").concat(value.slice(3, 6), "-").concat(value.slice(6, 10)) : '';
}